module.exports = __webpack_public_path__ + "assets/img/37_1494.af5cc21f.jpg";